module.exports = __webpack_public_path__ + "img/en_st.f434036a.png";